import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getTransactionDetail } from "../../services/transactionService";
import { downloadTransactionPDF } from "./PdfFile";

const statusConfig = {
  SUCCESS:  { cls: "bg-emerald-50 text-emerald-700 border border-emerald-200", icon: "M5 13l4 4L19 7" },
  REFUNDED: { cls: "bg-amber-50 text-amber-600 border border-amber-200",   icon: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" },
  PENDING:  { cls: "bg-blue-50 text-blue-600 border border-blue-200",      icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" },
  FAILED:   { cls: "bg-red-50 text-red-600 border border-red-200",         icon: "M6 18L18 6M6 6l12 12" },
};

export default function TransactionDetails() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(false);

  const txId = state?.tx?.transaction_id || state?.tx?.id;

  useEffect(() => {
    if (!txId) return;
    setLoading(true);
    getTransactionDetail(txId)
      .then((res) => setApiData(res.data?.data || res.data))
      .catch(() => toast.error("Failed to load transaction details"))
      .finally(() => setLoading(false));
  }, [txId]);

  const raw = apiData || state?.tx;
  const data = {
    id:                raw?.transaction_id   || raw?.id               || "—",
    date:              raw?.created_at ? new Date(raw.created_at).toLocaleDateString() : (raw?.date || "—"),
    time:              raw?.created_at ? new Date(raw.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : (raw?.time || "—"),
    status:            raw?.status           || "SUCCESS",
    serviceType:       raw?.service?.name    || raw?.service_name     || raw?.accountType || "—",
    // ip:                raw?.ip_address       || raw?.ip               || "—",
    utr:               raw?.utr              || raw?.utr_id            || "—",
    // partner_request_id: raw?.partner_request_id || raw?.request_id        || "—",
    // idRef:             raw?.provider_ref     || raw?.reference_id     || raw?.bankRef     || "—",
    netTotal:          raw?.net_amount != null ? `₹${parseFloat(raw.net_amount).toFixed(2)}` : (raw?.amount != null ? `₹${parseFloat(raw.amount).toFixed(2)}` : "—"),
    grossAmount:       raw?.amount != null   ? `₹${parseFloat(raw.amount).toFixed(2)}`      : "—",
    serviceCommission: raw?.commission != null ? `₹${parseFloat(raw.commission).toFixed(2)}` : "—",
    message:           raw?.provider_message || raw?.message          || "—",
  };

  const status = statusConfig[data.status?.toUpperCase()] || statusConfig.SUCCESS;

  const downloadPDF = () => downloadTransactionPDF(data);

  if (loading) return (
    <div className="flex items-center justify-center py-16">
      <div className="w-10 h-10 border-2 border-[#4B2364] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  return (
        <div className="flex-1 overflow-y-auto p-6">
          <div className="max-w-6xl mx-auto space-y-8">

            {/* Header */}
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <button
                    onClick={() => navigate(-1)}
                    className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                  >
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4B2364" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
                    </svg>
                  </button>
                  <h1 className="text-[32px] font-bold text-[#4B2364]">Transaction Details</h1>
                </div>
                {/* <p className="text-[14px] text-[#34094D] font-semibold ml-10 flex items-center gap-1">
                  <button onClick={() => navigate(-1)} className="text-[#4C444E] hover:underline cursor-pointer bg-transparent border-none p-0">
                    Transactions
                  </button>
                  <span>›</span>
                  <span className="font-mono">{data.id}</span>
                </p> */}
              </div>
              <div className="flex gap-2">
                <button onClick={downloadPDF} className="flex items-center gap-1.5 text-[14px] font-semibold text-[#191C1D] border border-[#CEC3D01A] shadow-[0px_1px_2px_0px_#0000000D] bg-white rounded-[12px] px-[24px] py-[10px] transition cursor-pointer">
                  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Receipt
                </button>
                {/* <button className="flex items-center gap-1.5 text-[14px] font-semibold text-[#191C1D] border border-[#CEC3D01A] shadow-[0px_1px_2px_0px_#0000000D] bg-white rounded-[12px] px-[24px] py-[10px] transition cursor-pointer">
                  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                  </svg>
                  Share
                </button> */}
              </div>
            </div>

            {/* Partner Request Card */}
            <div className="bg-white shadow-[0px_24px_32px_0px_#4B23640A] rounded-[24px] p-8">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] uppercase tracking-widest mb-1.5">Transaction ID</p>
                    <p className="text-[24px] font-bold text-[#34094D] font-mono tracking-tight">{data.id}</p>
                </div>
                <span className={`flex items-center gap-1.5 text-xs font-bold px-[18px] py-[8px] rounded-full ${status.cls}`}>
                  <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d={status.icon} />
                  </svg>
                  {data.status}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4 pt-2">
                {/* Service Type */}
                <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] uppercase tracking-widest mb-2">Service Type</p>
                  <div className="flex items-center gap-2">
                    <span className="w-8 h-8 rounded-[12px] bg-[#E9BCFE4D] flex items-center justify-center shrink-0">
                      <svg width="18" height="18" fill="none" stroke="#34094D" strokeWidth={2} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </span>
                    <span className="text-[17px] font-semibold text-[#191C1D]">{data.serviceType}</span>
                  </div>
                </div>

                {/* IP Address */}
                <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] uppercase tracking-widest mb-2">Utr</p>
                  <div className="flex items-center gap-1.5">
                    <svg width="18" height="18" fill="none" stroke="#4C444E" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18" />
                    </svg>
                    <span className="text-[17px] font-semibold text-[#191C1D]">{data.utr}</span>
                  </div>
                </div>

                {/* ID Reference */}
                {/* <div>
                  <p className="text-[12px] font-semibold text-[#4C444E] uppercase tracking-widest mb-2">Partner Request ID</p>
                  <span className="text-[14px] font-mono text-[#34094D] bg-[#F3F4F5] rounded-[6px] px-[12px] py-[8px] block">
                    {data.partner_request_id}
                  </span>
                </div> */}
              </div>
            </div>

            {/* Financial Summary */}
            <div className="bg-white shadow-[0px_24px_32px_0px_#4B23640A] rounded-[24px] p-8">
              <h3 className="text-[20px] font-bold text-[#191C1D] mb-4">Financial Summary</h3>
              <div className="space-y-3">

                <div className="flex justify-between items-center py-3 border-b border-[#CEC3D01A]">
                  <span className="text-[16px] font-medium text-[#4C444E]">Gross Amount</span>
                  <span className="text-[20px] font-semibold text-[#191C1D]">{data.grossAmount}</span>
                </div>

                <div className="flex justify-between items-center py-3 border-b border-[#CEC3D01A]">
                  <span className="text-[16px] text-[#4C444E] font-medium flex items-center gap-1.5">
                    Service Commission
                  </span>
                  <span className={`text-[20px] font-semibold ${
                    data.serviceCommission === "—" ? "text-gray-400"
                    : data.serviceType.toLowerCase().includes("payin") || data.serviceType.toLowerCase().includes("pay_in")
                    ? "text-red-500" : "text-emerald-500"
                  }`}>
                    {data.serviceCommission !== "—" && (
                      data.serviceType.toLowerCase().includes("payin") || data.serviceType.toLowerCase().includes("pay_in")
                        ? "- " : "+ "
                    )}
                    {data.serviceCommission}
                  </span>
                </div>

                <div className="flex justify-between items-end pt-2">
                  <span className="text-[18px] font-bold text-[#34094D] uppercase">Net Total Amount</span>
                  <div className="text-right">
                    <p className="text-[30px] font-semibold bg-gradient-to-r from-[#754F89] to-[#4B2364] bg-clip-text text-transparent">{data.netTotal}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  );
}
